"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userUpdatePhone = exports.userUpdate = exports.userReadPricingFormulaId = exports.userReadFcmRegistrationTokens = exports.userRead = void 0;
const FetchHelper_1 = __importDefault(require("../helpers/FetchHelper"));
const deserializeArray_1 = __importDefault(require("../models/deserializeArray"));
const deserializeString_1 = require("../models/deserializeString");
const PricingFormulaType_1 = require("../models/PricingFormulaType");
const User_1 = require("../models/User");
const PATH = 'users';
async function userRead(uid, database, unrestricted = false) {
    const result = await database.read(PATH, uid);
    if (unrestricted) {
        // return more than what would be deserialized -- return full object
        (0, User_1.userDeserialize)(result.value, result.id);
        return Object.assign({ id: result.id }, result.value);
    }
    return (0, User_1.userDeserialize)(result.value, result.id);
}
exports.userRead = userRead;
async function userReadFcmRegistrationTokens(uid, database) {
    const result = await database.read(`/${PATH}/${uid}`, 'fcmRegistrationTokens');
    return (0, deserializeArray_1.default)(deserializeString_1.deserializeString)(result.value);
}
exports.userReadFcmRegistrationTokens = userReadFcmRegistrationTokens;
async function userReadPricingFormulaId(uid, type, database) {
    const result = await database.read(`/${PATH}/${uid}`, (0, PricingFormulaType_1.pricingFormulaTypePropertyName)(type));
    return (0, deserializeString_1.deserializeString)(result.value);
}
exports.userReadPricingFormulaId = userReadPricingFormulaId;
/**
 * You shouldn't write directly to the `/users` node. Instead, specify the user type, and the correct node will be selected
 */
async function userUpdate(type, uid, values, database) {
    let path;
    switch (type) {
        case 'CUSTOMER':
            path = 'customers';
            break;
        case 'DRIVER':
            path = 'drivers';
            break;
        default:
            throw new Error('Invalid user type');
    }
    await database.update(path, uid, values);
}
exports.userUpdate = userUpdate;
async function userUpdatePhone(user, phone, code, waveApiUrl) {
    return FetchHelper_1.default.json(`${waveApiUrl}/users/${user.uid}/phone`, {
        value: phone,
        code,
    }, {
        method: 'PUT',
        headers: await FetchHelper_1.default.firebaseAuthorization(user),
    });
}
exports.userUpdatePhone = userUpdatePhone;
